/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blob_Save_Dialog_FailedInputs */



/**
* | output |
* | --- |
* | "Could not save the file. Please try again." |
*
* @param {Chat_Blob_Save_Dialog_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_failed = /** @type {((inputs?: Chat_Blob_Save_Dialog_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei konnte nicht gespeichert werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Could not save the file. Please try again.")
});